module.exports = __webpack_public_path__ + "img/images-stack.705bfe81.svg";